import imgMaze_ from "./Maze.png";
import imgTicTacToe_ from "./TicTacToe.png";
import imgPuzzle_ from "./Puzzle.png";
import imgMinesweeper_ from "./Minesweeper.png";
import imgSnake_ from "./Snake.png";

export const imgMaze = imgMaze_;
export const imgTicTacToe = imgTicTacToe_;
export const imgPuzzle = imgPuzzle_;
export const imgMinesweeper = imgMinesweeper_;
export const imgSnake = imgSnake_;